export class Award {
    image: String = '';
    name: String = '';
}



// WEBPACK FOOTER //
// ./src/app/award.ts